export default {
  isDev: process.env.NODE_ENV !== 'production',
  iframeRoute: process.env.IFRAME_ROUTE,
  apiRoute: process.env.API_ROUTE,
  theme: process.env.THEME,
  exchangeApiRoute: process.env.EXCHANGE_ROUTE,
  eventApiRoute: process.env.EVENT_API_ROUTE,
  pricesApiRoute: process.env.PRICES_API_ROUTE,
  aggregatedApiRoute: process.env.AGGREGATED_API_ROUTE,
  ticketsApiRoute: process.env.TICKETS_API_ROUTE,
  yMetrikaID: process.env.Y_METRIKA,
  yMetrikaIDMarket: process.env.Y_METRIKA_MARKET,
};
